var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c(_vm.currentComponent,{ref:this.destination.type,tag:"component",attrs:{"isCompany":_vm.isCompany,"isAdmin":_vm.isAdmin},on:{"change-form":_vm.changeForm}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }